// File: src/pages/Admin/TaskList.js

import React, { useState, useEffect } from 'react'
import { auth, db } from '../../firebase'
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc
} from 'firebase/firestore'
import { onAuthStateChanged } from 'firebase/auth'
import { Navigate } from 'react-router-dom'

// ← import your ProfileSubmission form
import ProfileSubmission from './ProfileSubmission'

export default function TaskList() {
  const [user, setUser] = useState(null)
  const [tasks, setTasks] = useState([])

  // 1) listen for auth changes & then your user’s tasks
  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, u => {
      if (!u) {
        setUser(false)
        return
      }
      setUser(u)

      // query only tasks assigned to their email
      const q = query(
        collection(db, 'tasks'),
        where('assignedTo', '==', u.email)
      )
      const unsubTasks = onSnapshot(q, snap => {
        setTasks(snap.docs.map(d => ({ id: d.id, ...d.data() })))
      })
      return unsubTasks
    })
    return unsubAuth
  }, [])

  if (user === null) return <p>Loading…</p>
  if (user === false) return <Navigate to="/admin/login" replace />

  // 2) accept & progress helpers
  const acceptTask = id =>
    updateDoc(doc(db, 'tasks', id), { status: 'accepted' })
  const updateProgress = (id, prog) =>
    updateDoc(doc(db, 'tasks', id), { progress: prog })

  return (
    <div style={{ padding: 20 }}>
      <h2>My Tasks</h2>

      {tasks.length === 0 && <p>No tasks assigned.</p>}

      {tasks.map(t => {
        // normalize your template ID
        const tmpl = t.template?.toLowerCase()

        // decide whether to show the ProfileSubmission form
        const showProfileForm =
          (tmpl === 'profilesubmission' || tmpl === 'profile') &&
          t.status === 'accepted'

        return (
          <div
            key={t.id}
            style={{
              border: '1px solid #ccc',
              padding: 12,
              marginBottom: 12
            }}
          >
            <h3>{t.title}</h3>
            <p>
              <strong>Template:</strong> {t.template}
            </p>

            {showProfileForm ? (
              // 3) render the actual ProfileSubmission form in-place
              <ProfileSubmission />
            ) : (
              <>
                <p>
                  <strong>Status:</strong> {t.status}
                </p>
                <p>
                  <strong>Progress:</strong> {t.progress}%
                </p>

                {t.status === 'pending' && (
                  <button onClick={() => acceptTask(t.id)}>
                    Accept
                  </button>
                )}

                <div style={{ marginTop: 8 }}>
                  <label>
                    Update Progress:
                    <input
                      type="number"
                      min="0"
                      max="100"
                      value={t.progress}
                      onChange={e =>
                        updateProgress(
                          t.id,
                          parseInt(e.target.value, 10) || 0
                        )
                      }
                      style={{ width: 60, marginLeft: 8 }}
                    />
                    %
                  </label>
                </div>
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}
